<template>
  <Navbar v-if="showNavbar" />
  <NavbarSecondary v-if="showNavbarSecondary" />
  <div class="page-content" :class="{ 'background-theme': backgroundTheme }">
    <div class="content-wrapper">
      <div class="content-inner">
        <div
          class="content"
          :class="{
            'd-flex justify-content-center align-items-center': addClass,
          }"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/commons/Navbar.vue'
import NavbarSecondary from '@/components/commons/NavbarSecundary.vue'

export default {
  name: 'Layout',

  components: {
    Navbar,
    NavbarSecondary,
  },

  data() {
    return {
      routesName: ['Auth', 'Unauthorized', 'NotFound'],
    }
  },

  computed: {
    showNavbar() {
      return !this.routesName.includes(this.$route.name)
    },

    showNavbarSecondary() {
      return this.$route.name === 'CCDetalhes'
    },

    backgroundTheme() {
      return this.$route.name === 'Auth'
    },

    addClass() {
      return this.routesName.includes(this.$route.name)
    },
  },
}
</script>

<style scoped>
.background-theme {
  background-color: #00756a;
}
</style>
